import { initialState } from './initialState';

const migrations = {
    1: state => {
        console.log({ migrationstate1: state });
        const newState = Object.assign({}, initialState, state);
        return newState;
    },
    2: state => {
        console.log({ migrationstate1: state });
        const newState = Object.assign({}, initialState, state);
        return newState;
    },
};

export default migrations;



// WEBPACK FOOTER //
// ./src/reducers/migrations.js